/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
	Container,
	Box,
	Flex,
	Text,
	Center,
	Badge,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	useToast,
	Tooltip,
	Wrap,
	WrapItem,
	Avatar,
	Button,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogBody,
	AlertDialogFooter,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionIcon,
	AccordionPanel,
	AspectRatio,
	Image,
	Divider,
	useDisclosure,
} from '@chakra-ui/react';
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import { faPrint, faMinusSquare, faPlusSquare, faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CheckIcon, WarningIcon, RepeatIcon, SpinnerIcon } from '@chakra-ui/icons';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import ViewComment from '../../components/Comment/ViewComment';
import PrintLayout from '../../components/Print/PrintLayout';
import DownloadAndViewButton from '../../components/Files/DownloadAndViewButton';
import SelectUserModal from '../../components/Modal/SelectUserModal';
import DoneFileUplaod from '../../components/ComplaintOnInsurance/DoneFileUplaod';
import UserDislayNameById from '../../components/UserDislayNameById';
import useStore from '../../store';
import moment from 'moment';
import c from '../../constant';
import './style.css';

import 'moment/locale/en-gb';
import 'moment/locale/km';

import OldDetail from './components/old_detail';
import NewDetail from './components/new_detail';

import Modal from '../../components/form/CompanyPickerFormField/PublicModal';
import useMoment from '../../hooks/useMoment';

import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';
import UserReplyLetterFile from '../../components/ComplaintOnInsurance/UserReplyLetterUpload';

const leftLabelWidth = '200px';

const QUERY_COMPLAINT = gql`
	query get($id: String!) {
		getComplaintOnInsuranceById(id: $id) {
			id
			no
			complaintOnInsuranceCategories
			plaintiff
			name
			gender
			dob
			plaintiffIdCard
			state
			district
			commune
			village
			streetNumber
			houseNumber
			phoneNumber
			email
			socialMediaUrl
			representative
			companyName
			companyObjects
			address
			subject
			reason
			complaintId
			cause
			demand
			proof
			signatureOrFingerPrintOfPlaintiffOrRepresentative
			plaintiffOrRepresentativeName
			plaintiffOrRepresentativePhoneNumber
			copyOfIdCard
			copyOfBusinessLicense
			copyOfInsuranceAgreement
			proofFile
			transferComplaintFile
			otherFile
			createdAt
			complaintType
			settled
			settledDate
			spam
			plaintiffReplyLetterFile
			adminComplaintStatus
			withdrawReason
			plaintiffResolutionAcceptance
			resolutionDenialReason
			complaintOnCompany {
				id
				name
				nameKhmer
				logo
				url
				type
			}
			notification {
				read
			}
			assignTo {
				user {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
				createdBy
				createdAt
			}
			doneFile
			signatureOrFingerPrintOfPlaintiffOrRepresentativeMobile
			copyOfIdCardMobile
			copyOfBusinessLicenseMobile

			proofFileMobile

			otherFileMobile
			platform
		}
	}
`;

const MUTATION_SETTLED_COMPLAINT = gql`
	mutation settled($id: String!) {
		settledComplaintOnInsuranceById(id: $id)
	}
`;

const QUERY_SET_AS_SPAM = gql`
	mutation setComplaintOnInsuranceByIdAsSpam($id: String!) {
		setComplaintOnInsuranceByIdAsSpam(id: $id)
	}
`;

const QUERY_SET_AS_NOT_SPAM = gql`
	mutation setComplaintOnInsuranceByIdAsNotSpam($id: String!) {
		setComplaintOnInsuranceByIdAsNotSpam(id: $id)
	}
`;

const MUTATION_ASSIGN_USER = gql`
	mutation assign($id: String!, $userId: String!) {
		assignComplaintOnInsuranceToUser(id: $id, userId: $userId)
	}
`;

const MUTATION_REMOVE_USER = gql`
	mutation remove($id: String!, $userId: String!) {
		removeAssignedComplaintOnInsuranceFromUser(id: $id, userId: $userId)
	}
`;

const MUTATION_SET_INPROGRESS_COMPLAINT = gql`
	mutation set($id: String!) {
		setComplaintOnInsuranceByIdAsInprogress(id: $id)
	}
`;

const MUTATION_ASSIGN_COMPANY = gql`
	mutation set(
		$subject: String!
		$ComplaintAssignTypes: ComplaintAssignTypes!
		$status: StatusTypes!
		$complaintId: String!
		$companyId: String!
		$no: String!
		$data: JSON!
	) {
		createComplaintAssignmentRecord(
			subject: $subject
			ComplaintAssignTypes: $ComplaintAssignTypes
			status: $status
			complaintId: $complaintId
			companyId: $companyId
			no: $no
			data: $data
		)
	}
`;

const QUERY_ASSIGNED_COMPANY = gql`
	query getAssignedCompanyDetails($companyId: String!) {
		getAssigedCompanyByCompanyId(companyId: $companyId) {
			name
			nameKhmer
			logo
		}
	}
`;

const QUERY_LOAD_ASSIGNED_COMPANY = gql`
	query loadAssignedCompany($complaintId: String!) {
		getExistingAssignedCompanyByComplaintId(complaintId: $complaintId) {
			id
			companyId
			replyLetter
			status
			note
		}
	}
`;

const MUTATION_REMOVE_ASSIGNED_COMPANY = gql`
	mutation removeAssignedCompany($id: String!) {
		removeAssingedComanyById(id: $id)
	}
`;

const UPDATE_STATUS = gql`
	mutation ChangeStatusById($id: String!, $status: StatusTypes!) {
		changeStatusById(id: $id, status: $status)
	}
`;

function ComplaintDetail() {
	const toast = useToast();
	const { t } = useTranslation();
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const id = urlParams.get('id') ? urlParams.get('id') : null;
	const { currentLang } = useStore((state) => state.currentLang);
	const [complaint, setComplaint] = useState(null);
	const { currentUser } = useStore((state) => state.currentUser);
	const [loadComplaint, { error, loading, data }] = useLazyQuery(QUERY_COMPLAINT);
	const [settledComplaintById, { data: settledData }] = useMutation(MUTATION_SETTLED_COMPLAINT);
	const [setAsSpamComplaint, { error: errorSetAsSpam, data: dataSetAsSpam }] = useMutation(QUERY_SET_AS_SPAM);
	const [setAsNotSpamComplaint, { error: errorSetAsNotSpam, data: dataSetAsNotSpam }] = useMutation(QUERY_SET_AS_NOT_SPAM);
	const setCountUnreadNotifications = useStore((state) => state.setCountUnreadNotifications);
	const { countUnreadNotifications } = useStore((state) => state.countUnreadNotifications);
	const [assignUserMutation, { error: errorAssign, data: dataAssign }] = useMutation(MUTATION_ASSIGN_USER);
	const [setInprogressComplaintById, { data: setInprogressData }] = useMutation(MUTATION_SET_INPROGRESS_COMPLAINT);
	const [isOpen, setIsOpen] = useState(false);
	const [removingUserId, setRemovingUserId] = useState(null);
	const [selectUserModalOpen, setSelectUserModalOpen] = useState(false);
	const cancelRef = useRef();
	const onClose = () => setIsOpen(false);
	const [removeUserMutation, { error: errorRemove, loading: loadingRemove, data: dataRemove }] = useMutation(MUTATION_REMOVE_USER);
	const { isOpen: companyAssignModal, onOpen: companyAssignModalOpen, onClose: companyAssignModalClose } = useDisclosure();
	const [CompanyInfo, setCompanyInfo] = useState(null);
	const [assignCompanyMutation, { data: dataAssignCompany, error: errorAssignCompany, loading: loadingAssignCompany }] = useMutation(MUTATION_ASSIGN_COMPANY);
	const [getAssignedCompanyDetails, { data: dataAssignedCompany, error: errorAssignedCompany }] = useLazyQuery(QUERY_ASSIGNED_COMPANY);
	const [loadAssignedCompany, { data: dataLoadAssignedCompany, loading: loadingLoadAssignedCompany }] = useLazyQuery(QUERY_LOAD_ASSIGNED_COMPANY);
	const [loadCompanyAssignedData, setLoadCompanyAssignedData] = useState(null);
	const [displayAddCompany, setdisplayAddCompany] = useState(false);
	const [openRemoveCompanyBox, setOpenRemoveCompanyBox] = useState(false);
	const displayRemoveCompanyBox = () => setOpenRemoveCompanyBox(true);
	const hideRemoveCompanyBox = () => setOpenRemoveCompanyBox(false);
	const [removeAssignedCompanyById, { data: dataRemoveAssignedCompany, error: errorRemoveAssignedCompany, loading: loadingRemoveAssignedCompany }] =
		useMutation(MUTATION_REMOVE_ASSIGNED_COMPANY);
	const [updateStatus, { data: dataUpdateStatus, loading: loadingUpdateStatus }] = useMutation(UPDATE_STATUS);
	const { paperSolarDateString, paperLunarDateString } = useMoment();

	useEffect(() => {
		if (data?.getComplaintOnInsuranceById) {
			console.log('complaint data:', data?.getComplaintOnInsuranceById);
		}
	}, [data]);

	useEffect(() => {
		if (errorRemoveAssignedCompany) {
			if (errorRemoveAssignedCompany?.graphQLErrors?.length > 0) {
				errorRemoveAssignedCompany?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'top-right',
					})
				);
			} else {
				toast({
					title: t(errorRemoveAssignedCompany?.message ? errorRemoveAssignedCompany?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				});
			}
		}
	}, [errorRemoveAssignedCompany]);

	useEffect(() => {
		if (errorAssignedCompany) {
			if (errorAssignedCompany?.graphQLErrors?.length > 0) {
				errorAssignedCompany?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'top-right',
					})
				);
			} else {
				toast({
					title: t(errorAssignedCompany?.message ? errorAssignedCompany?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				});
			}
		}
	}, [errorAssignedCompany]);

	useEffect(() => {
		if (errorAssignCompany) {
			if (errorAssignCompany?.graphQLErrors?.length > 0) {
				errorAssignCompany?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'top-right',
					})
				);
			} else {
				toast({
					title: t(errorAssignCompany?.message ? errorAssignCompany?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				});
			}
		}
	}, [errorAssignCompany]);

	useEffect(() => {
		if (dataRemoveAssignedCompany) {
			setLoadCompanyAssignedData(null);
			setdisplayAddCompany(false);
			toast({
				title: t('Company removed successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [dataRemoveAssignedCompany]);

	useEffect(() => {
		if (dataLoadAssignedCompany) {
			setLoadCompanyAssignedData(dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId);
		}

		if (dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.companyId) {
			getAssignedCompanyDetails({
				variables: {
					companyId: dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.companyId,
				},
			});
		}
	}, [dataLoadAssignedCompany]);

	useEffect(() => {
		if (dataAssignCompany) {
			loadAssignedCompany({
				variables: {
					complaintId: id,
				},
			});
		}
	}, [dataAssignCompany]);

	useEffect(() => {
		if (dataAssignCompany) {
			toast({
				title: t('Company assigned successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [dataAssignCompany]);

	useEffect(() => {
		if (dataAssignCompany || dataLoadAssignedCompany) {
			setdisplayAddCompany(true);
		}
	}, [dataAssignCompany, dataLoadAssignedCompany]);

	useEffect(() => {
		if (CompanyInfo?.id && id) {
			if (complaint?.complaintType === 'COMPLAINT') {
				assignCompanyMutation({
					variables: {
						subject: complaint?.subject,
						ComplaintAssignTypes: 'COMPLAINT',
						status: 'NEED_REPLY',
						complaintId: id,
						companyId: CompanyInfo?.id,
						no: complaint?.no,
						data: {
							solarDate: paperSolarDateString(),
							lunarDate: paperLunarDateString(),
						},
					},
				});
			} else if (complaint?.complaintType === 'CANCELATION_COMPLAINT') {
				assignCompanyMutation({
					variables: {
						subject: complaint?.subject,
						ComplaintAssignTypes: 'CANCELATION_COMPLAINT',
						status: 'NEED_REPLY',
						complaintId: id,
						companyId: CompanyInfo?.id,
						no: complaint?.no,
						data: {
							solarDate: paperSolarDateString(),
							lunarDate: paperLunarDateString(),
						},
					},
				});
			}
			getAssignedCompanyDetails({
				variables: {
					companyId: CompanyInfo?.id,
				},
			});
		}
	}, [CompanyInfo]);

	moment.locale(currentLang === 'kh' ? 'km' : 'en-gb');

	useEffect(() => {
		if (dataRemove?.removeAssignedComplaintOnInsuranceFromUser) {
			toast({
				title: t('User removed successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({
				variables: {
					id,
				},
			});
			onClose();
		}
	}, [dataRemove]);

	useEffect(() => {
		if (errorRemove) {
			toast({
				title: t('Remove assigned user error'),
				status: 'error',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [errorRemove]);

	useEffect(() => {
		window.scrollTo(0, 0);
		loadComplaint({ variables: { id } });
		loadAssignedCompany({
			variables: {
				complaintId: id,
			},
		});
	}, []);

	useEffect(() => {
		if (id) {
			loadComplaint({ variables: { id } });
		}
	}, [id]);

	useEffect(() => {
		if (data?.getComplaintOnInsuranceById) {
			setComplaint(data?.getComplaintOnInsuranceById);
		}
	}, [data]);

	function complaintType(type) {
		return type === 'COMPLAINT' ? <Badge colorScheme="purple">{t('Complaint')}</Badge> : <Badge colorScheme="green">{t('Cancel Complaint')}</Badge>;
	}

	function row(label, value) {
		return (
			<Flex style={{ pageBreakInside: 'avoid' }} p="2" _hover={{ bg: 'gray.200' }} align={'center'}>
				<Text mr="2" fontWeight="500" w="200px" minW="200px">
					{t(label)}:
				</Text>
				<Box>
					{value?.file ? (
						<Box>
							<DownloadAndViewButton url={value?.file} size={value?.fileSize} marginLeft={0} />
						</Box>
					) : (
						<>
							<Text>{value ? t(value) : 'N/A'}</Text>
						</>
					)}
				</Box>
			</Flex>
		);
	}

	function FileViewer({ label = null, platform = null, file = null, files = [], labelWeight = '500', p = 1, pl = 2 }) {
		return (
			<Flex justifyContent="flex-start" alignItems="center" p={p} pl={pl} pr={2} style={{ pageBreakInside: 'avoid' }} _hover={{ bg: 'gray.200' }}>
				<Text mr="2" fontWeight={labelWeight} w="200px" minW="200px">
					{t(label)}:
				</Text>
				{platform === 'mobile' ? (
					<Box width="200px">
						{files?.length > 0 ? (
							<>
								<Accordion allowToggle allowMultiple bg="gray.100" borderRadius={2}>
									<AccordionItem border="none">
										<AccordionButton backgroundColor="gray.100" _hover={{ backgroundColor: 'gray.100' }}>
											<Box as="span" flex="1" textAlign="left">
												<Flex justifyContent="flex-start" alignItems="center">
													<Text fontWeight="normal" fontSize="sm">
														{t('Files')}
													</Text>
													&nbsp;
													<Text fontWeight="semibold" fontSize="md">{`(${files?.length})`}</Text>
												</Flex>
											</Box>
											<AccordionIcon />
										</AccordionButton>
										<AccordionPanel>
											{files?.map((file, i) => (
												<Box key={i} mb={i === files?.length - 1 ? 0 : 2}>
													<DownloadAndViewButton url={file?.url} size={file?.size} marginLeft={0} />
												</Box>
											))}
										</AccordionPanel>
									</AccordionItem>
								</Accordion>
							</>
						) : (
							<>
								<Text>N/A</Text>
							</>
						)}
					</Box>
				) : (
					<Box width="200px">
						{file?.file ? (
							<>
								<DownloadAndViewButton url={file?.file} size={file?.fileSize} marginLeft={0} />
							</>
						) : file?.url ? (
							<>
								<DownloadAndViewButton url={file?.url} size={file?.size} marginLeft={0} />
							</>
						) : (
							<>
								<Text>N/A</Text>
							</>
						)}
					</Box>
				)}
			</Flex>
		);
	}

	useEffect(async () => {
		if (settledData) {
			toast({
				title: t('Complaint settled'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			if (loadCompanyAssignedData?.id) {
				await updateStatus({
					variables: {
						id: loadCompanyAssignedData?.id,
						status: 'SETTLED',
					},
				});
			}
			loadComplaint({ variables: { id } });
			loadAssignedCompany({
				variables: {
					complaintId: id,
				},
			});
		}
	}, [settledData]);

	function setSettledComplaint() {
		settledComplaintById({ variables: { id } });
	}

	function getStatus({ settled, settledDate }) {
		return settled === true ? (
			<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
				<Badge colorScheme="green">{t('Settled')}</Badge>
			</Tooltip>
		) : (
			<Badge colorScheme="yellow">{t('In progress')}</Badge>
		);
	}

	function newGetStatus({ settled, settledDate, status }) {
		if (settled === false && !status) {
			return <Badge colorScheme="yellow">{t('In progress')}</Badge>;
		} else if (status === 'NEED_REPLY') {
			return <Badge colorScheme="orange">{t('Waiting for company reply')}</Badge>;
		} else if (status === 'IN_PROGRESS') {
			return <Badge colorScheme="blue">{t('Received company reply')}</Badge>;
		} else if (settled === true) {
			return (
				<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
					<Badge colorScheme="green">{t('Settled')}</Badge>
				</Tooltip>
			);
		}
	}

	useEffect(() => {
		if (errorSetAsSpam) {
			toast({
				title: t('Set as spam error'),
				status: 'error',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [errorSetAsSpam]);

	useEffect(() => {
		if (errorSetAsNotSpam) {
			toast({
				title: t('Set as not spam error'),
				status: 'error',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [errorSetAsNotSpam]);

	useEffect(() => {
		if (dataSetAsNotSpam?.setComplaintOnInsuranceByIdAsNotSpam) {
			toast({
				title: t('Set as not spam successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({ variables: { id } });
		}
	}, [dataSetAsNotSpam]);

	useEffect(() => {
		if (dataSetAsSpam?.setComplaintOnInsuranceByIdAsSpam) {
			toast({
				title: t('Set as spam successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({ variables: { id } });
		}
	}, [dataSetAsSpam]);

	function setSpam() {
		setAsSpamComplaint({ variables: { id } });
	}

	function setNotSpam() {
		setAsNotSpamComplaint({ variables: { id } });
	}

	useEffect(() => {
		if (data?.getComplaintOnInsuranceById?.notification?.read === false) {
			setCountUnreadNotifications(countUnreadNotifications - 1);
		}
	}, [data]);

	function getDisplayName(user) {
		let result = user?.username;
		if (currentLang === 'kh') {
			if ((result = user?.fullNameKhmer)) {
				result = user?.fullNameKhmer;
			} else {
				if (user?.fullName) {
					result = user?.fullName;
				} else {
					result = user?.username;
				}
			}
		} else {
			if ((result = user?.fullName)) {
				result = user?.fullName;
			} else {
				if (user?.fullNameKhmer) {
					result = user?.fullNameKhmer;
				} else {
					result = user?.username;
				}
			}
		}

		return result;
	}

	function removeAssignUserDialog(user) {
		setIsOpen(true);
		setRemovingUserId(user);
	}

	function selectAssignUser(userData) {
		assignUserMutation({ variables: { id: id, userId: userData?.id } });
	}

	useEffect(() => {
		if (errorAssign) {
			if (errorAssign?.graphQLErrors?.length > 0) {
				errorAssign?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'top-right',
					})
				);
			} else {
				toast({
					title: t(errorAssign?.message ? errorAssign?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				});
			}
		}
	}, [errorAssign]);

	useEffect(() => {
		if (dataAssign?.assignComplaintOnInsuranceToUser) {
			toast({
				title: t('User assigned successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({ variables: { id } });
		}
	}, [dataAssign]);

	function setInprogressComplaint() {
		setInprogressComplaintById({ variables: { id: id } });
	}

	useEffect(() => {
		if (setInprogressData?.setComplaintOnInsuranceByIdAsInprogress) {
			toast({
				title: t('Complaint set to in progress successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({ variables: { id } });
		}
	}, [setInprogressData]);

	function getIdForAssignedCompanyRemoval() {
		if (dataAssignCompany?.createComplaintAssignmentRecord) return dataAssignCompany?.createComplaintAssignmentRecord;
		if (dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.id) return dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.id;
	}

	function getPlaintiffReplyStatus(replyresult) {
		switch (replyresult) {
			case 'AGREE':
				return (
					<Badge ml="4" colorScheme="green">
						{t('AGREE')}
					</Badge>
				);
			case 'DISAGREE':
				return (
					<Badge ml="4" colorScheme="red">
						{t('DISAGREE')}
					</Badge>
				);
			default:
				return (
					<Badge ml="4" colorScheme="gray">
						N/A
					</Badge>
				);
		}
	}

	return (
		<>
			<PrintLayout>
				<>
					<Container maxW="container.xl" mt="16px" mb="16px">
						<BreadcrumbComponent
							list={[
								{
									name: 'COMPLAINT',
									path: '/complaint-type',
								},
								{
									name: 'COMPLAINT ON INSURANCE',
									path: '/complaint-on-insurance?page=1',
								},
								{
									name: 'DETAIL',
									path: '#',
								},
							]}
						/>
						<Center mt="5">
							<Box
								w="100%"
								bg="white"
								borderRadius={c.borderRadius}
								border="1px solid #dbdbdb"
								boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
								pb="32px"
							>
								<Flex
									justifyContent="space-between"
									alignItems="center"
									bg="#FAFAFA"
									p="16px"
									pt="8px"
									pb="8px"
									mb="0px"
									borderBottom="1px solid #dbdbdb"
								>
									<Flex alignItems="center">
										<Text fontSize="x-large" fontWeight="bold" mr="4">
											{t('Complaint On Insurance')}
										</Text>
										{data?.getComplaintOnInsuranceById?.complaintType && (
											<>
												<>{complaintType(data?.getComplaintOnInsuranceById?.complaintType)}</>
											</>
										)}
										{data?.getComplaintOnInsuranceById?.platform === 'mobile' && (
											<Badge ml={1} colorScheme="blue">
												{t('Mobile')}
											</Badge>
										)}
										{data?.getComplaintOnInsuranceById?.spam === true && (
											<Badge ml={1} colorScheme="red">
												{t('Spam')}
											</Badge>
										)}
									</Flex>
									<Flex className="hidden-print">
										<Button
											onClick={() => window?.print()}
											leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
											colorScheme="gray"
											variant="solid"
											size="sm"
											borderRadius={c.borderRadius}
											border="1px solid #bdc3c7"
										>
											{t('Print')}
										</Button>
										{currentUser?.role === 'admin' && (
											<>
												{!error && data?.getComplaintOnInsuranceById?.id && (
													<Menu>
														<MenuButton cursor="pointer">
															<Button
																colorScheme="gray"
																variant="solid"
																size="sm"
																borderRadius={c.borderRadius}
																border="1px solid #bdc3c7"
																ml={2}
															>
																<FontAwesomeIcon icon={faEllipsisH} style={{ fontSize: 16 }} />
															</Button>
														</MenuButton>
														<MenuList pt="4" pb="4" pl="3" pr="3" borderRadius={c.borderRadius}>
															{data?.getComplaintOnInsuranceById?.settled === false && currentUser.role === 'admin' && (
																<MenuItem icon={<CheckIcon />} color="green" onClick={() => setSettledComplaint()}>
																	{t('Settled')}
																</MenuItem>
															)}
															{/* {data?.getComplaintOnInsuranceById?.settled === true && currentUser.role === 'admin' && (
																<MenuItem icon={<SpinnerIcon />} onClick={() => setInprogressComplaint()}>
																	{t('In progress')}
																</MenuItem>
															)} */}
															{data?.getComplaintOnInsuranceById?.spam === false && (
																<MenuItem icon={<WarningIcon />} onClick={() => setSpam()}>
																	{t('Spam')}
																</MenuItem>
															)}
															{data?.getComplaintOnInsuranceById?.spam === true && (
																<MenuItem icon={<RepeatIcon />} onClick={() => setNotSpam()}>
																	{t('Not Spam')}
																</MenuItem>
															)}
														</MenuList>
													</Menu>
												)}
											</>
										)}
									</Flex>
								</Flex>

								{loading && (
									<Flex p={4} pb={0} justifyContent="center" alignItems="center">
										<Text>{t('Loading')}</Text>
									</Flex>
								)}

								{error && (
									<Flex p={4} pb={0} justifyContent="center" alignItems="center">
										<Text>{t(error?.message)}</Text>
									</Flex>
								)}

								{data?.getComplaintOnInsuranceById && (
									<Box p="16px" pb="0px">
										{data?.getComplaintOnInsuranceById?.representative === null ? (
											<OldDetail FileViewer={FileViewer} complaint={complaint} row={row} getStatus={getStatus} />
										) : (
											(data?.getComplaintOnInsuranceById?.representative === 'yes' ||
												data?.getComplaintOnInsuranceById?.representative === 'no') && (
												<NewDetail
													FileViewer={FileViewer}
													complaint={complaint}
													row={row}
													newGetStatus={newGetStatus}
													loadData={loadCompanyAssignedData}
												/>
											)
										)}

										{/* <Flex alignItems="center" mt="2" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="bold" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Assign to company')}:
											</Text>
											<Wrap ml={2}>
												<Flex direction="column" justifyContent="center" alignItems="center">
													{displayAddCompany && (
														<WrapItem className="avatarWraper">
															<Box position="relative" display="inline-block">
																{loadCompanyAssignedData?.status !== 'SETTLED' && (
																	<FontAwesomeIcon
																		onClick={displayRemoveCompanyBox}
																		className="remove"
																		icon={faMinusSquare}
																		style={{
																			fontSize: 18,
																			display: 'none',
																			position: 'absolute',
																			top: -6,
																			right: -4,
																			zIndex: '100',
																			marginLeft: 32,
																			color: 'red',
																			backgroundColor: 'transparent',
																			padding: 2,
																			cursor: 'pointer',
																		}}
																	/>
																)}
																<Box>
																	<Flex justifyContent="center">
																		<Image
																			// maxW="70px"
																			maxH="40px"
																			h="auto"
																			w="auto"
																			src={c.baseFilePath + dataAssignedCompany?.getAssigedCompanyByCompanyId.logo}
																			alt={`${dataAssignedCompany?.getAssigedCompanyByCompanyId.name} - ${dataAssignedCompany?.getAssigedCompanyByCompanyId.nameKhmer}`}
																			objectFit="contain"
																			fallbackSrc="/files/images/no-logo.png"
																		/>
																	</Flex>
																</Box>
															</Box>
														</WrapItem>
													)}
													{displayAddCompany && (
														<Text textAlign="center">
															{currentLang === 'en'
																? dataAssignedCompany?.getAssigedCompanyByCompanyId?.name
																: dataAssignedCompany?.getAssigedCompanyByCompanyId?.nameKhmer}
														</Text>
													)}
												</Flex>
											</Wrap>
											<Wrap>
												<Flex>
													{!loadCompanyAssignedData && complaint?.settled === true && (
														<>
															<Text>N/A</Text>
														</>
													)}
												</Flex>
											</Wrap>
											<Wrap>
												{!displayAddCompany && complaint?.settled === false && (
													<Flex>
														<Button
															className="hidden-print"
															onClick={companyAssignModalOpen}
															leftIcon={<FontAwesomeIcon icon={faPlusSquare} style={{ fontSize: 18 }} />}
															colorScheme="blue"
															variant="outline"
														>
															{t('Add')}
														</Button>
													</Flex>
												)}
											</Wrap>
										</Flex> */}

										{/* <Flex alignItems="center" mt="2" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Flex
												justifyContent="flex-start"
												alignItems="center"
												pr={2}
												style={{ pageBreakInside: 'avoid' }}
												_hover={{ bg: 'gray.200' }}
											>
												<Text mr="2" fontWeight="bold" w="200px" minW="200px">
													{t('note')}:
												</Text>
												{loadCompanyAssignedData?.note ? (
													<Box width="200px">
														<>
															<DownloadAndViewButton url={loadCompanyAssignedData?.note?.url} marginLeft={0} />
														</>
													</Box>
												) : (
													<>
														<Text>N/A</Text>
													</>
												)}
											</Flex>
										</Flex>
										<Flex alignItems="center" mt="2" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<FileViewer
												label="Reply Letter"
												file={dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.replyLetter}
												labelWeight="bold"
												p={0}
												pl={0}
											/>
										</Flex>
										<Divider h="1px" mt="8" mb="8" /> */}

										<Flex alignItems="center" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Reply Letter to Plaintiff')}:
											</Text>
											<Box>
												<UserReplyLetterFile
													id={id}
													callback={() => {
														window.scrollTo(0, 0);
														setTimeout(() => {
															loadComplaint({
																variables: {
																	id,
																},
															});
														}, 500);
													}}
													existingReplyLetterFile={data?.getComplaintOnInsuranceById?.plaintiffReplyLetterFile}
													assignerNames={data?.getComplaintOnInsuranceById?.plaintiffReplyLetterAssigner}
												/>
											</Box>
										</Flex>

										<Flex style={{ pageBreakInside: 'avoid' }} p="2" _hover={{ bg: 'gray.200' }} align={'center'}>
											<Text mr="2" fontWeight="500" w="200px" minW="200px">
												{t('Answer to Reply Letter')}:
											</Text>
											{getPlaintiffReplyStatus(data?.getComplaintOnInsuranceById?.plaintiffResolutionAcceptance)}
										</Flex>

										<Flex style={{ pageBreakInside: 'avoid' }} p="2" _hover={{ bg: 'gray.200' }} align={'center'}>
											<Text mr="2" fontWeight="500" w="200px" minW="200px">
												{t('Reason of Disagreement')}:
											</Text>
											<Text ml="4">
												{data?.getComplaintOnInsuranceById?.resolutionDenialReason
													? data?.getComplaintOnInsuranceById.resolutionDenialReason
													: 'N/A'}
											</Text>
										</Flex>

										<Divider h="1px" mt="8" mb="8" />

										<Flex alignItems="center" mt="2" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="bold" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Assign to')}:
											</Text>
											<Wrap ml={2}>
												{data?.getComplaintOnInsuranceById?.assignTo?.map((aTo, index) => {
													return (
														<Flex direction="column" justifyContent="center" alignItems="center" key={'u-' + index}>
															<Tooltip
																label={
																	<>
																		{t('Assign By')}&nbsp;
																		<UserDislayNameById id={aTo?.createdBy} />
																		&nbsp;{', '}&nbsp;
																		{moment(aTo.createdAt).format('LLLL')}
																	</>
																}
															>
																<WrapItem className="avatarWraper">
																	{(currentUser?.role === 'admin' || currentUser?.canAssignUserToComplaint) &&
																		currentUser?.id !== aTo?.user?.id && (
																			<FontAwesomeIcon
																				onClick={() => removeAssignUserDialog(aTo?.user)}
																				className="remove"
																				icon={faMinusSquare}
																				style={{
																					fontSize: 18,
																					display: 'none',
																					position: 'absolute',
																					zIndex: '100',
																					marginLeft: 32,
																					color: 'red',
																					backgroundColor: 'white',
																					padding: 2,
																					cursor: 'pointer',
																				}}
																			/>
																		)}
																	<Avatar
																		name={getDisplayName(aTo?.user)}
																		src={aTo?.user?.avatar?.icon ? c.baseFilePath + aTo?.user?.avatar?.icon : null}
																	/>
																</WrapItem>
															</Tooltip>
															<Text textAlign="center">{getDisplayName(aTo.user)}</Text>
														</Flex>
													);
												})}
												{(currentUser?.role === 'admin' || currentUser?.canAssignUserToComplaint) && (
													<Flex>
														<Button
															className="hidden-print"
															onClick={() => setSelectUserModalOpen(true)}
															leftIcon={<FontAwesomeIcon icon={faPlusSquare} style={{ fontSize: 18 }} />}
															colorScheme="blue"
															variant="outline"
														>
															{t('Add')}
														</Button>
													</Flex>
												)}
											</Wrap>
										</Flex>
										<Flex alignItems="center" mt={2} p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="bold" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Done')}:
											</Text>
											{data?.getComplaintOnInsuranceById?.settled ? (
												<>
													{data?.getComplaintOnInsuranceById?.doneFile ? (
														<Box>
															<DownloadAndViewButton
																url={data?.getComplaintOnInsuranceById?.doneFile?.file}
																size={data?.getComplaintOnInsuranceById?.doneFile?.fileSize}
																marginLeft={2}
															/>
														</Box>
													) : (
														<Text ml={2}>N/A</Text>
													)}
												</>
											) : (
												<>
													{currentUser?.role === 'admin' || currentUser?.canUploadDoneFileToComplaint ? (
														<Box ml={-2}>
															<DoneFileUplaod
																id={id}
																callback={() => {
																	window.scrollTo(0, 0);
																	setTimeout(() => {
																		loadComplaint({
																			variables: {
																				id,
																			},
																		});
																	}, 500);
																}}
															/>
														</Box>
													) : (
														<Text ml={2}>N/A</Text>
													)}
												</>
											)}
										</Flex>
									</Box>
								)}
							</Box>
						</Center>
						{data?.getComplaintOnInsuranceById?.id && <ViewComment id={data?.getComplaintOnInsuranceById?.id} type="COMPLAINT_ON_INSURANCE" />}
					</Container>

					{selectUserModalOpen && (
						<SelectUserModal
							role="complaint"
							callback={selectAssignUser}
							isOpen={selectUserModalOpen}
							onClose={() => setSelectUserModalOpen(false)}
						/>
					)}

					<AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
						<AlertDialogOverlay>
							<AlertDialogContent>
								<AlertDialogHeader fontSize="lg" fontWeight="bold">
									{t('Remove Assigned User')}
								</AlertDialogHeader>

								<AlertDialogBody>
									{t(`Are you sure you want to remove`)} "{getDisplayName(removingUserId)}"?
								</AlertDialogBody>

								<AlertDialogFooter>
									<Button ref={cancelRef} onClick={onClose}>
										{t('Cancel')}
									</Button>
									<Button
										isLoading={loadingRemove}
										colorScheme="red"
										onClick={() => {
											removeUserMutation({
												variables: {
													id: id,
													userId: removingUserId?.id,
												},
											});
										}}
										ml={3}
									>
										{t('Remove')}
									</Button>
								</AlertDialogFooter>
							</AlertDialogContent>
						</AlertDialogOverlay>
					</AlertDialog>

					<AlertDialog isOpen={openRemoveCompanyBox} leastDestructiveRef={cancelRef} onClose={hideRemoveCompanyBox}>
						<AlertDialogOverlay>
							<AlertDialogContent>
								<AlertDialogHeader fontSize="lg" fontWeight="bold">
									{t('Remove Assigned Company')}
								</AlertDialogHeader>

								<AlertDialogBody>
									{t(`Are you sure you want to remove`)} "
									{currentLang === 'en'
										? dataAssignedCompany?.getAssigedCompanyByCompanyId?.name
										: dataAssignedCompany?.getAssigedCompanyByCompanyId?.nameKhmer}
									"?
								</AlertDialogBody>

								<AlertDialogFooter>
									<Button ref={cancelRef} onClick={hideRemoveCompanyBox}>
										{t('Cancel')}
									</Button>
									<Button
										isLoading={loadingRemoveAssignedCompany}
										colorScheme="red"
										onClick={() => {
											const existingId = getIdForAssignedCompanyRemoval();
											removeAssignedCompanyById({
												variables: {
													id: existingId,
												},
											});
											hideRemoveCompanyBox();
										}}
										ml={3}
									>
										{t('Remove')}
									</Button>
								</AlertDialogFooter>
							</AlertDialogContent>
						</AlertDialogOverlay>
					</AlertDialog>

					{companyAssignModal && <Modal companyTypes={null} isOpen={true} onClose={companyAssignModalClose} onCallback={(e) => setCompanyInfo(e)} />}
				</>
			</PrintLayout>
			{(loadingAssignCompany || loadingLoadAssignedCompany || loadingUpdateStatus) && <LoadingOverlay />}
		</>
	);
}

export default ComplaintDetail;
